export const lang = {
    lang: 'What about English?'
}